import React from "react";
import { withI18n, WithI18nHocPropsType } from "@al/next/al-ex";
import { Avatar, Rate, Image } from "antd-mobile";
import classnames from "classnames";
import _get from "lodash/get";

import Iconfont from "~/components/ui/Iconfont";
import { formatTime } from "~/common/utils/formatTime";

import { EvaluationItemProps, EvaluationItemType } from "./types";
import styles from "./style.scss";

function EvaluationItem(props: EvaluationItemProps & WithI18nHocPropsType): JSX.Element {
  const { type = EvaluationItemType.EvaluationPage, wrapClassName, isLast, detail, t } = props;
  const { commentInfo, orderSkuInfo, nickName, avatar } = detail || {};
  // 现在只有两种情况 就这么判断吧 后续有变化再看
  const imgCount = EvaluationItemType.EvaluationPage === type ? 3 : 4;
  const handleClick = (commentId: number, index: number): void => {
    props?.clickImg?.(commentId, index);
  };

  // 检查specs 是否为空值，因为这里是json串，只有 "{}" 这一个异常值，快速判断一下就可以了
  const checkSpecsEmpty = (specs: string): boolean => {
    if (specs === "{}") return true;
    return !specs;
  };

  // 渲染规格
  const renderSpecs = (specs: string): string => {
    try {
      const spec = JSON.parse(specs);
      return Object.keys(spec).reduce((acc, next, index) => {
        let temp = acc;
        temp = `${temp}${index === 0 ? "" : " "}${next}: ${spec[next]}`;
        return temp;
      }, "");
    } catch {
      return specs;
    }
  };

  return (
    <div className={classnames(styles.evaluation, { [styles.border]: !isLast }, wrapClassName)}>
      <div className={styles.evaluation_head}>
        <div className={styles.evaluation_basic}>
          <Avatar className={styles.evaluation_avatar} src={avatar} />
          <div className={styles.evaluation_info}>
            <div className={styles.evaluation_name}>
              <span className={styles.evaluation_name_ellipsis}>{commentInfo?.self ? t("我的评价") : nickName}</span>
              {type === EvaluationItemType.DetailModule && (
                <Rate
                  allowHalf
                  character={<Iconfont name="score_yellow" />}
                  className={styles.evaluation_rate__small}
                  readOnly
                  value={_get(commentInfo, "goodsGrade")}
                />
              )}
            </div>
            <div className={styles.evaluation_desc}>
              <span className={styles.evaluation_time}>{formatTime(Number(_get(commentInfo, "commentTime")))}</span>
              {checkSpecsEmpty(_get(orderSkuInfo, "skuSpecValues")) || (
                <>
                  <span className={styles.divider}></span>
                  <span className={classnames(styles.evaluation_spec, styles.evaluation_spec__ellipsis)}>
                    {renderSpecs(_get(orderSkuInfo, "skuSpecValues") || "")}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
        {type === EvaluationItemType.EvaluationPage && (
          <div className={styles.evaluation_grade}>
            {t("评分")}
            <Rate
              allowHalf
              character={<Iconfont name="score_yellow" />}
              className={styles.evaluation_rate}
              readOnly
              value={_get(commentInfo, "goodsGrade")}
            />
          </div>
        )}
      </div>
      <div
        className={classnames(styles.evaluation_main, {
          [styles.ml_0]: type === EvaluationItemType.DetailModule,
        })}
      >
        <div className={styles.evaluation_text}>{_get(commentInfo, "content")}</div>
        <div className={styles.evaluation_img}>
          {(_get(commentInfo, "images") || []).map((item: string, i: number) => (
            <Image
              key={`${item}-${i}`}
              className={classnames(styles.evaluation_img_item, {
                [styles.mr_0]: (i + 1) % imgCount === 0,
                [styles.mt_8]: i >= imgCount,
              })}
              src={item}
              onClick={(): void => handleClick(_get(commentInfo, "commentId"), i)}
              width={imgCount === 3 ? "0.92rem" : "0.76rem"}
              height={imgCount === 3 ? "0.92rem" : "0.76rem"}
              fit="cover"
            />
          ))}
        </div>
        {_get(commentInfo, "replyContent") && (
          <div className={styles.evaluation_reply}>
            <div className={styles.evaluation_reply_title}>{t("商家回复")}: </div>
            <div className={styles.evaluation_reply_content}>{_get(commentInfo, "replyContent")}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default withI18n("evalutationItem", {
  en: require("./i18n/in.json"),
  in: require("./i18n/in.json"),
  ms: require("./i18n/in.json"),
  vi: require("./i18n/in.json"),
  zh: require("./i18n/in.json"),
})(EvaluationItem);
